var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showDisplayOptions)?_c('div',{staticClass:"display-options"},[_c('BaseSwitch',{attrs:{"switchedOffText":"3","switchedOnText":"2","value":_vm.twoColumn},on:{"valueChanged":_vm.columnSwitchChange}})],1):_vm._e(),_c('div',{staticClass:"video-container",attrs:{"id":_vm.elementId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }